const blogToggleMenuButton = document.querySelector("[data-blog-toggle-menu-button]");
const blogMenuList = document.querySelector("[data-blog-menu]");
let newsArticle = document.querySelector(".news__article");
let blogCategoryList = document.querySelector(".blog-menu__list");
let featuredBlogPost = document.querySelector(".featured-blogpost");
let blogMenuListAnchor = $(".blog-menu__list").find("a");
let blogMenu = $(".blog-menu");
let ulWidth = 0, maxTranslateX = 0, liWidth = 0, positionLeft = 0;
let ul = $(".blog-menu__list");
let prevButton = blogMenu.find(".blog-menu__prev");
let nextButton = blogMenu.find(".blog-menu__next");

function blogInit() {

	if (blogToggleMenuButton && blogMenuList) {
		blogToggleMenuButton.addEventListener("click", function () {
			blogMenuList.classList.toggle("is-visible");
			blogToggleMenuButton.classList.toggle("is-active");
		});
	}

	$('a.featured-blogpost, p.featured-blogpost__text__cta, .featured-blogpost h2, .featured-blogpost__image-wrapper').on("click", (e) => {
		trackFeaturedArticleClick(e);
	});

	$('a.featured-blogpost, p.featured-blogpost__text__cta, .featured-blogpost h2, .featured-blogpost__image-wrapper').on("auxclick", (e) => {
		trackFeaturedArticleClick(e);
	});

	$('.blog-overview__articles-grid a').on('click', (e) => {
		trackArticleClick(e);
	});

	$('.blog-overview__articles-grid a').on('auxclick', (e) => {
		trackArticleClick(e);
	});

	$(window).on("resize", blogCategoryHeight);
	nextButton.on("click", goToNext);
	prevButton.on("click", goToPrevious);

	blogCategoryHeight();
	changeIntroCopyPosition();
	changeTagPosition();

	if (blogMenu.length > 0) {
		onResize();
	}

	function blogCategoryHeight() {
		if (blogCategoryList && window.matchMedia("(min-width: 480px)").matches) {
			let blogHeight = 0;
			if (featuredBlogPost) {
				$(window).on('load', function () {
					blogHeight = window.matchMedia("(min-width: 1024px)").matches ? (featuredBlogPost.clientHeight - 80) : (featuredBlogPost.clientHeight - 82);
					blogCategoryAdjust(blogHeight);
				});
			}
			if (newsArticle) {
				blogHeight = newsArticle.clientHeight - 118;
				blogCategoryAdjust(blogHeight);
			}
		}
	}

	function blogCategoryAdjust(blogHeight) {
		if (blogCategoryList.scrollHeight > blogHeight) {
			blogCategoryList.style.height = blogHeight + "px";
			blogCategoryList.style.overflowY = "scroll";
		}
	}

	function trackArticleClick(e) {
		let articleAnchor = e.target.closest('a'),
			articleTitle = articleAnchor.querySelector('h3').innerText.trim();

		shvenergy.tracking.trackRawEventData({
			'event': 'clickArticle',
			'articleName': articleTitle
		});
	}

	function trackFeaturedArticleClick(e) {
		let target = e.target,
			container = target.closest('.featured-blogpost'),
			articleName = container ? container.querySelector('h2').innerText : '';

		articleName = articleName ? articleName.trim() : '';

		shvenergy.tracking.trackRawEventData({
			'event': 'clickFeaturedArticle',
			'articleName': articleName
		});
	}

	function onResize() {
		let wrapWidth = blogMenu[0].getBoundingClientRect().width;
		ulWidth = calcUlWidth(wrapWidth);
		maxTranslateX = ulWidth - wrapWidth;
		calcLIWidth(blogMenuListAnchor.filter("a.is-active"), wrapWidth, 'load');
		goToBlogCategory();
	}

	function calcUlWidth(wrapWidth) {
		let width = 0;
		let columnGaps = (ul.find("li").length - 1) * 12;
		ul.find("li").each(function () {
			if (width === 0) {
				positionLeft = $(this).position().left;
			}
			width += $(this).width();
		});

		if (width > wrapWidth) {
			width += positionLeft;
		}

		return width + columnGaps;
	}

	function calcLIWidth(activeAnchor, wrapWidth, type) {
		let count = 0, liWidthWithGap = 0;
		activeAnchor = blogMenuListAnchor.index(activeAnchor);
		ul.find("li").each(function () {
			if (count < activeAnchor) {
				liWidth += $(this).width();
			}
			if (count == activeAnchor) {
				liWidthWithGap = liWidth + $(this).width() + count * 12;
			}
			count++;
		});
		if (type === "load") {
			liWidthWithGap > (wrapWidth - 50) ? liWidth : liWidth = 0;
		}
	}

	function goToBlogCategory() {
		let offset = liWidth;
		if (offset > maxTranslateX) {
			offset = maxTranslateX + 1;
		}

		offset = parseInt(offset);
		document.querySelector(".blog-menu__list").scrollLeft = offset;

		if (offset > 0) {
			toggleBtn(prevButton, true);
		} else {
			toggleBtn(prevButton, false);
		}

		if (offset >= maxTranslateX) {
			toggleBtn(nextButton, false);
		} else {
			toggleBtn(nextButton, true);
		}
		liWidth = 0;
	}

	function goToNext() {
		calcLIWidth(getRightCategoryItem().find("a"));
		goToBlogCategory();
	}

	function goToPrevious() {
		calcLIWidth(getLeftCategoryItem().find("a"));
		goToBlogCategory();
	}

	function getRightCategoryItem() {
		let containerWidth = blogMenu.width();
		let rightElement;
		ul.find("li").each(function () {
			rightElement = $(this);
			if (rightElement.offset().left < containerWidth && rightElement.offset().left + rightElement.width() > containerWidth) {
				return false;
			}
		});

		return rightElement;
	}

	function getLeftCategoryItem() {
		let leftOffset = positionLeft - blogMenu.width();
		let leftElement;
		let liList = ul.find("li");
		liList.each(function () {
			leftElement = $(this);
			if (leftElement.offset().left > leftOffset) {
				return false;
			}
		});

		if (!leftElement && liList.length > 0) {
			leftElement = $(ul.find("li").get(0));
		}

		return leftElement;
	}

	function changeIntroCopyPosition() {
		const subHeader = document.querySelector(".subheader");
		const articleHeroImage = document.querySelector(".blog__article__hero");
		const linesHeight = subHeader ? Math.round(parseFloat(window.getComputedStyle(subHeader).lineHeight)) * 6 : 0;

		if (subHeader && articleHeroImage && subHeader.scrollHeight > linesHeight) {
			const parent = subHeader.parentNode;
			const temp = document.createElement('div');

			parent.insertBefore(temp, subHeader);
			parent.insertBefore(subHeader, articleHeroImage);
			parent.insertBefore(articleHeroImage, temp);
			parent.removeChild(temp);
		}
	}

	function changeTagPosition() {
		if (window.matchMedia("(max-width: 750px)").matches && document.querySelector(".blog__article__tag-container")) {
			$(".blog__article__tag-container").insertAfter(".blog__article__somesharebutton");
		}
	}

	function toggleBtn(btn, show) {
		if (show) {
			btn.animate({ opacity: 1 }, 100, function () {
				btn.show();
			});
		} else {
			btn.animate({ opacity: 0 }, 100, function () {
				btn.hide();
			});
		}
	}
}

blogInit();
